export const isUpperCase = (string: string) => (
  string === String(string).toUpperCase()
);
